import { UpdateNotificationTemplate } from '@frontend/notification/types';
import { useState } from 'react';

import { UpdateTemplateModalProps } from './update-template-modal.component';

export const useUpdateTemplateModal = (props: UpdateTemplateModalProps) => {
    const templateFormId = 'update-notification-template-form';
    const [formValues, setFormValues] = useState<UpdateNotificationTemplate>({ ...props.template });

    return {
        templateFormId,
        setFormValues,
        formValues
    };
};
